<template>
  <b-dropdown-form class="py-1 dropdown-filter-form-n">
    <b-row>
      <b-col cols="10">
        <p>Filters</p>
      </b-col>
      <b-col cols="2">
        <feather-icon
          icon="XIcon"
          size="16"
          class="align-right"
          @click="$emit('emitHideFilter')"
        />
      </b-col>
    </b-row>

    <b-form-group label="Product">
      <b-form-checkbox
        v-for="option in productOptions"
        :key="option"
        v-model="productTypeValue"
        :value="option"
      >
        {{ option }}
      </b-form-checkbox>
    </b-form-group>

    <b-form-group label="Need Type">
      <b-form-checkbox
        v-for="option in needTypeOptions"
        :key="option.value"
        v-model="needTypeValue"
        :value="option.value"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>

    <!-- Status is part of the department-routing workflow (stepper) that's not built yet - shown
         here to match the design, but not wired to any filtering until that exists. -->
    <b-form-group label="Status">
      <b-form-checkbox
        v-for="option in statusOptions"
        :key="option"
      >
        {{ option }}
      </b-form-checkbox>
    </b-form-group>

    <b-form-group label="Payment Status">
      <b-form-checkbox
        v-for="option in paymentStatusOptions"
        :key="option"
        v-model="paymentStatusValue"
        :value="option"
      >
        {{ option }}
      </b-form-checkbox>
    </b-form-group>

    <b-form-group label="Agent Rank">
      <b-form-checkbox
        v-for="option in rankOptions"
        :key="option.value"
        v-model="rankValue"
        :value="option.value"
      >
        {{ option.label }}
      </b-form-checkbox>
    </b-form-group>

    <b-form-group
      label="Agency"
      @click.native.stop
    >
      <b-form-input
        v-model="agencyValue"
        placeholder="Enter code or name"
      />
    </b-form-group>

    <!-- Pending Department depends on the same not-yet-built workflow as Status above. -->
    <b-form-group
      label="Pending Department"
      @click.native.stop
    >
      <v-select
        placeholder="Select from list"
        :options="[]"
      />
    </b-form-group>

    <b-form-group
      label="Submitted on"
      @click.native.stop
    >
      <b-input-group>
        <flat-pickr
          v-model="createdAtValue"
          class="form-control"
          placeholder="Select date range"
          :config="flatPickrConfig"
        />
        <b-input-group-append is-text>
          <feather-icon
            icon="CalendarIcon"
            class="cursor-pointer"
            data-toggle
            size="18"
          />
        </b-input-group-append>
      </b-input-group>
    </b-form-group>

    <b-form-group label="Agent Self-Purchase">
      <b-form-checkbox v-model="agentSelfPurchaseValue">
        Only SOs with agents as purchasers
      </b-form-checkbox>
    </b-form-group>

    <div class="d-flex mt-1">
      <b-button
        variant="outline-primary"
        size="md"
        class="mr-1 w-100"
        @click="clearFilter"
      >
        Clear All
      </b-button>
      <b-button
        variant="primary"
        size="md"
        class="w-100"
        @click="applyFilter"
      >
        Apply Filter
      </b-button>
    </div>
  </b-dropdown-form>
</template>

<script>
import {
  BDropdownForm, BFormGroup, BFormCheckbox, BFormInput, BButton, BRow, BCol, BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import '@core/scss/vue/libs/vue-flatpicker.scss'

export default {
  components: {
    BDropdownForm,
    BFormGroup,
    BFormCheckbox,
    BFormInput,
    BButton,
    BRow,
    BCol,
    BInputGroup,
    BInputGroupAppend,
    vSelect,
    flatPickr,
  },
  props: {
    productTypeFilter: {
      type: Array,
      default: () => [],
    },
    needTypeFilter: {
      type: Array,
      default: () => [],
    },
    paymentStatusFilter: {
      type: Array,
      default: () => [],
    },
    rankFilter: {
      type: Array,
      default: () => [],
    },
    agencyFilter: {
      type: String,
      default: '',
    },
    createdAtFilter: {
      type: String,
      default: '',
    },
    agentSelfPurchaseFilter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      productOptions: ['Niche', 'Pedestal', 'Little Buddha', 'Urn', 'Funeral Service Package'],
      needTypeOptions: [
        { value: 'PRE-NEED', label: 'Pre-need' },
        { value: 'AS-NEED', label: 'As-need' },
      ],
      statusOptions: ['Pending Payment', 'Processing', 'Action Required', 'Processed', 'Voided'],
      paymentStatusOptions: ['Paid', 'Overpaid', 'Partially Paid'],
      rankOptions: [
        { value: 'Probationary', label: 'Probationary Agent' },
        { value: 'SA', label: 'Service Advisor' },
        { value: 'SD', label: 'Service Director' },
        { value: 'DSD', label: 'District Service Director' },
        { value: 'BDD', label: 'Business Development Director' },
        { value: 'CBDD', label: 'Chief Business Development Director' },
      ],

      productTypeValue: JSON.parse(JSON.stringify(this.productTypeFilter)) || [],
      needTypeValue: JSON.parse(JSON.stringify(this.needTypeFilter)) || [],
      paymentStatusValue: JSON.parse(JSON.stringify(this.paymentStatusFilter)) || [],
      rankValue: JSON.parse(JSON.stringify(this.rankFilter)) || [],
      agencyValue: this.agencyFilter,
      createdAtValue: this.createdAtFilter,
      agentSelfPurchaseValue: this.agentSelfPurchaseFilter,
      flatPickrConfig: {
        wrap: true, mode: 'range', dateFormat: 'd/m/Y', enableTime: false, static: true, disableMobile: true,
      },
    }
  },
  watch: {
    productTypeFilter: {
      immediate: true,
      handler(val) { this.productTypeValue = JSON.parse(JSON.stringify(val)) || [] },
    },
    needTypeFilter: {
      immediate: true,
      handler(val) { this.needTypeValue = JSON.parse(JSON.stringify(val)) || [] },
    },
    paymentStatusFilter: {
      immediate: true,
      handler(val) { this.paymentStatusValue = JSON.parse(JSON.stringify(val)) || [] },
    },
    rankFilter: {
      immediate: true,
      handler(val) { this.rankValue = JSON.parse(JSON.stringify(val)) || [] },
    },
    agencyFilter: {
      immediate: true,
      handler(val) { this.agencyValue = val },
    },
    createdAtFilter: {
      immediate: true,
      handler(val) { this.createdAtValue = val },
    },
    agentSelfPurchaseFilter: {
      immediate: true,
      handler(val) { this.agentSelfPurchaseValue = val },
    },
  },
  methods: {
    applyFilter() {
      this.$emit('update:productTypeFilter', this.productTypeValue)
      this.$emit('update:needTypeFilter', this.needTypeValue)
      this.$emit('update:paymentStatusFilter', this.paymentStatusValue)
      this.$emit('update:rankFilter', this.rankValue)
      this.$emit('update:agencyFilter', this.agencyValue)
      this.$emit('update:createdAtFilter', this.createdAtValue)
      this.$emit('update:agentSelfPurchaseFilter', this.agentSelfPurchaseValue)
      this.$emit('apply')
      this.$emit('emitHideFilter')
    },
    clearFilter() {
      this.productTypeValue = []
      this.needTypeValue = []
      this.paymentStatusValue = []
      this.rankValue = []
      this.agencyValue = ''
      this.createdAtValue = ''
      this.agentSelfPurchaseValue = false
      this.applyFilter()
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
